import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { findUrl } from '../../helpers/findUrl'
import Button from '../../shared/Button/Button'
import useAllSitePage from '../../hooks/useAllSitePage'
import '../../helpers/font-awesome'
import './Footer.scss'

const Footer = ({ footer }) => {
  const pagesPath = useAllSitePage()

  const {
    allSitePage: pages,
  } = pagesPath
  
  return (
    <footer className="py-5 footer-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-5 col-lg-3 d-flex mb-4 justify-content-center">
            <div className="d-flex flex-column align-items-center ">
              <div className="d-flex mb-2 pt-2">
                {footer.networkLinks?.networkLinkContent?.map((socialNetwork, index) => {
                  return (
                    <a
                      key={`socialNetwork-${index}`}
                      href={socialNetwork.url}
                      target="_blank"
                      className={`btn btn-social m-1 btn-social-icon btn-${socialNetwork.style}`}
                      rel="noreferrer"
                      aria-label={socialNetwork.title}
                    > 
                      <FontAwesomeIcon icon={[socialNetwork.icon?.type, socialNetwork.icon?.code]} size="sm" />
                    </a>
                  )
                })}
              </div>
              <h5 className="text-white font-weight-medium text-center">
                {footer.networkLinks?.title}
              </h5>
            </div>
          </div>
          <div className="col-12 col-md-7 col-lg-9 mb-4">
            <div className="d-flex flex-wrap justify-content-sm-center align-items-center responsive-logos-footer">
              {footer?.logosList?.logos.length > 0
                ? footer.logosList.logos.map((logo, i) =>
                    logo.visible ? (
                      <a
                        href={logo.url}
                        target="about_blank"
                        key={`key-logo-footer-${i}`}
                      >
                        <img
                          src={logo.image?.url}
                          className="img-small-logo-footer my-2 mx-1"
                          alt="logoFooter01"
                        />
                      </a>
                    ) : null
                  )
                : null}
            </div>
          </div>
          <div className="col-12 col-md-8 col-lg-9 row mx-0">
            {footer.footerLinksList?.length > 0
              ? footer.footerLinksList.map((list, i) => {
                  return (
                    <div
                      className="col-12 col-md-6 col-lg-3 my-3"
                      key={`list-section-key-${i}`}
                    >
                      <div className="d-flex flex-column links-list-container">
                        <h6 className="text-uppercase links-list-title">{list.label}</h6>
                        {list.linkList?.length > 0
                          ? list.linkList.map((item, i) =>
                              item.p_ucc_page !== null ? (
                                <Link
                                  to={findUrl(item.p_ucc_page.slug, pages.nodes)}
                                  className="mb-2 link-list"
                                  key={`item-list-link-${i}`}
                                >
                                  {item.label}
                                </Link>
                              ) : (
                                <a
                                  href={item.url}
                                  className="link-list mb-2"
                                  target="about_blank"
                                  key={`item-list-a-${i}`}
                                >
                                  {item.label}
                                </a>
                              )
                            )
                          : null}
                      </div>
                    </div>
                  )
                })
              : null}
          </div>
          <div className="col-12 col-md-4 col-lg-2 my-3">
            <div className=" d-flex flex-column font-secondary labels-font-size responsive-buttons">
              {footer?.buttonList.length > 0 &&
                footer.buttonList.map((button, index) => (
                  <Button
                    classButton={`w-100 text-left button-form rounded-0 ${
                      button?.customButton?.variant === 'primary'
                        ? ' border-none'
                        : ''
                    }`}
                    key={'footer-button-' + index}
                    {...button}
                    matchPages={pages.nodes}
                    icon={button?.icon}
                    classContainer="mb-2 d-flex flex-grow-1"
                  />
                ))
              }
              {/* {fiscalData?.visible && (
                <a
                  className="btn-dark border-ucc-boton btn-outline-info d-flex justify-content-center align-items-center mb-2 flex-grow-1"
                  href={fiscalData.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="text-black" src={fiscalData.image.url} alt={fiscalData.title} />
                </a>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
